export const BEIAN_URL = 'https://beian.miit.gov.cn/';
